<template>
  <Body class="h-full" />
  <div
    v-show="loading"
    class="bg-teal-lightest flex h-full w-full items-center justify-center"
  >
    <ZnLoadingBar />
  </div>
  <NuxtLayout v-show="!loading">
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useSiteConfigurationStore } from '@/store/siteConfiguration'
import { useUserStore } from '~/store/user'
import { useHead } from '#imports'

const siteConfigurationStore = useSiteConfigurationStore()
const userStore = useUserStore()
const { loading } = storeToRefs(userStore)

useHead({
  title:
    siteConfigurationStore.siteConfiguration?.configuration?.seoConfig?.title,
  meta: [
    {
      name: 'description',
      content:
        siteConfigurationStore.siteConfiguration?.configuration?.seoConfig
          ?.description,
    },
  ],
  script: [
    {
      src: siteConfigurationStore.siteConfiguration?.configuration?.seoConfig?.script,
      tagPosition: 'bodyClose',
    },
    {
      src: 'https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js',
      tagPosition: 'bodyClose',
    },
    {
      src: 'https://pay.google.com/gp/p/js/pay.js',
      tagPosition: 'bodyClose',
    },
  ],
})
</script>
